// 用户信息
import {localStorageManage} from "@/common/localStorage/localStorageManage";

export const userInfo = getUserInfo()

// 清空本地数据
export function cleanUserInfo() {
    localStorage.removeItem(localStorageManage.user)
}

// 存储用户信息
export function saveUserInfo(data) {
    // console.log('saveUserInfo:   '+data)
    localStorage.setItem(localStorageManage.user, data)
}


export function getUserInfo() {
    let user
    try {
        user = JSON.parse(localStorage.getItem(localStorageManage.user))
    } catch (e) {
        user = ''
    }
    return user
}

